export default {
  "custom": {
    linkedReference: 'Összekapcsolt hivatkozás',
    boot: 'Bekapcsol',
    shutDown: 'Kikapcsol',
    notLinked: 'Nincs összekapcsolva',
    maxLinkedTip: 'Legfeljebb 2 {type} összekapcsolás engedélyezett, automatikusan visszaállítva Nincs összekapcsolva értékre',

    bar_Power: 'Tápvezérlés',
    bar_Video: 'Videóváltás',
    bar_Vol: 'Hangerő',
    bar_Audio: 'Hangváltás',
    bar_Serial: 'Soros vezérlés',
    bar_Air: 'Légkondicionáló',
    bar_Projection: 'Vetítővászon',
    bar_Remote: 'Távirányító',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Mindhárom képet egyszerre kell kiválasztania',
    notSelected: 'Nincs kiválasztva',
    choose: 'Válassz',
    disable: 'Letiltás',
    "longPressAndDrag": "Hosszan nyomja meg és húzza az elemek sorrendjének módosításához",
    "isrestoreDefault": "Visszaállítja az alapértelmezett állapotot?",
    "saveAndSync": "Mentés és szinkronizálás",
    "restoreDefault": "Alapértelmezett visszaállítása",
    "limitPNG": "Csak PNG képek tölthetők fel!",
    "limit1M": "A kép mérete nem haladhatja meg az 1 MB-ot!",
    "selectTheImage": "Kép kiválasztása",
    "textsuggestions": "Ajánlott: 48*48 px fehér PNG ikon, 1MB alatt",
    "iconLibrary": "Ikonkönyvtár",
    "panelNavigationBarCustomization": "Panel navigációs sáv",
    "logoCustomization": "Panel logó"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'A csatlakozás sikertelen: ez a Microsoft-bérlő (azonosító: ',
    AuthVerify4004Two: ') már foglalt a(z) [',
    AuthVerify4004Three: '] szervezet által. Újracsatlakozáshoz először válassza le az eredeti szervezetről, vagy használjon másik Microsoft-bérlőt.',
    theMicrosoftTenantIsOccupied: 'A Microsoft-bérlő foglalt',
    Viewtutorial: 'Kötési útmutató megtekintése',
    checktenantID: 'Kérjük, ellenőrizze, hogy a bérlő azonosítója, alkalmazás azonosítója és alkalmazáskulcs helyes-e.',
    ErrorCode: 'Hibakód:',
    AuthorizationFailed: 'Engedélyezés sikertelen',
    Accesshasbeengranted: 'A Microsoft Graph API-hoz való hozzáférés engedélyezve',
    successfullyauthorizedDescribe: 'A szükséges engedélyek sikeresen meg lettek adva. A tárgyalóterem adatok automatikusan szinkronizálódnak. Kérjük, zárja be ezt az oldalt.',
    Close: 'Bezárás',
    resourceID: 'Erőforrás azonosító',
    dialogTips: 'Tippek',
    theAuthorizationIsDeleted: 'Engedély törölve',
    theBindingIsSuccessful: 'Kötés sikeres',
    theUnbindingIsSuccessful: 'Kötés feloldása sikeres',
    unbindingFailed: 'Kötés feloldása sikertelen',
    theUnbindingHasBeenUnbound: 'Kötés feloldása megszakítva',
    continueUnbinding: 'Az Outlook szinkronizálás leáll, és minden közelgő esemény törlődik. Folytatja a kötés feloldását?',
    areYouSureAboutUnbinding: 'Minden közelgő Outlook esemény törlődik és a szinkronizálás leáll. Ez a művelet nem vonható vissza. Biztosan feloldja a kötést?',
    UnbindNotSynchronized: 'Kötés után az új Outlook események automatikusan szinkronizálódnak ehhez a teremhez (a korábbi események nem szinkronizálódnak)',
    unbinding: 'Kötés feloldása',
    bindUnableToSelect: 'Már kötve van, kiválasztás nem lehetséges',
    permissAThird: 'Kérjük, engedélyezze a harmadik féltől származó erőforrások kötését',
    resourceMailbox: 'Erőforrás postafiók:',
    PleasecheckID: 'Engedélyezés sikertelen! Kérjük, ellenőrizze, hogy a bérlő azonosítója, alkalmazás azonosítója és ügyfél titka helyes-e.',
    Waitingforauthorization: 'Engedélyezésre vár...',
    Pleasecompletetheauthorization: 'A Microsoft 365 bejelentkezési oldal megnyílt. Kérjük, jelentkezzen be rendszergazdai fiókkal az engedélyezés befejezéséhez.',
    pleaseEnterTheTenantID: 'Kérjük, adja meg a bérlő azonosítót',
    pleaseEnterTheClientID: 'Kérjük, adja meg az alkalmazás azonosítót',
    pleaseEnterTheClientSecret: 'Kérjük, adja meg az ügyfél titkot',
    Authorizationcompleted: 'Engedélyezés befejezve',
    Authorizelogin: 'Microsoft 365 bejelentkezés engedélyezése',
    ApplicationID: 'Bérlő azonosító',
    ClientID: 'Alkalmazás azonosító',
    ClientSecret: 'Ügyfél titok',
    registTipOne: 'Kérjük, kövesse a',
    registTipTwo: 'Kötési útmutatót',
    registTipThree: 'Az Azure alkalmazás regisztrációjának és engedélybeállításainak elvégzése után töltse ki az alábbi mezőket.',
    MicrosoftDescribe: 'A Microsoft 365-hoz való kötéssel az Outlook/Teams-ben foglalt értekezletek automatikusan szinkronizálódnak a Q-NEX Konzollal és a Tárgyalóterem Ütemezővel.',
    Addcalendarservice: 'Naptár szinkronizálási beállítások',
    Lasttimesynchronization: 'Utolsó szinkronizálás időpontja',
    Allocated: 'Hozzárendelve',
    Total: 'Összesen',
    Conferenceroomresources: 'Tárgyalóterem erőforrások',
    Bindingtime: 'Kötés időpontja',
    Bindtheplatform: 'Kötési platform',
    Synchronousstate: 'Szinkronizálási állapot',
    Organizationname: 'Szervezet neve',
    Bindthirdpartycalendar: 'Harmadik féltől származó naptár kötése',
    TenantIDTip: 'Egyedi azonosító az Azure AD-ben',
    ApplicationIDTip: 'Az Azure-ban regisztrált alkalmazás azonosító',
    ApplicationSecretTip: 'Az Azure-ban generált ügyfél titkos kulcs hitelesítéshez'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Üresjárati megjelenítési szöveg',
    IdleDisplayText: 'Üresjárati megjelenítési szöveg:',
    IdleDisplayTextContent: 'A szöveg, amely üres tárgyaló esetén jelenik meg (alapértelmezett: „Szabad”)',

    duplicateMeetingRoomName: 'Duplikált tárgyalónév',
    duplicateMeetingRoomNameContent: 'Már létezik "{duplicate_content}" nevű tárgyaló. Kérjük, adjon meg egy másik nevet.',
    NumberOfRoomPanels: 'Terem panelek száma',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Az aktuális terminál már egy másik szervezethez van kötve.",
    "theTerminalNameOrIDIsDuplicated": "A panel neve vagy azonosítója azonos",
    theRoomNameOrIDIsDuplicated: 'A tárgyaló neve vagy helye már létezik.',
    "AddMeetingRoom": "Konferenciaterem hozzáadása",
    "EditMeetingRoom": "Konferenciaterem szerkesztése",
    "MeetingRoomName": "Konferenciaterem neve:",
    "Location": "Elhelyezkedés:",
    "ReservationApproval": "Foglalási jóváhagyás:",
    "ApprovalListYes": "igen",
    "ApprovalListNo": "nem",
    "Capacity": "Kapacitás:",
    "RoomStatus": "Szoba állapota:",
    "BindRoomDisplay": "Panel hozzárendelése:",
    "meeting_btnAdd": "Hozzáadás",
    "meeting_btnEdit": "Szerkesztés",
    "meeting_btnBind": "Eszköz hozzárendelése",
    "meeting_btnDel": "Törlés",
    "meeting_tableRoomName": "Konferenciaterem neve",
    "meeting_tableRoomPlace": "Elhelyezkedés",
    "meeting_tableAppointmentApproval": "Foglalási jóváhagyás",
    "meeting_tableCapacityForPeople": "Kapacitás",
    "meeting_tableMeetingRoomStatus": "Szoba állapota",
    "meeting_tableAvaliable": "Elérhető",
    "meeting_tableOutofService": "Karbantartás alatt",
    "meeting_tableDoorBind": "Ajtó hozzárendelése",
    "meeting_tableBindNPS": "NPS hozzárendelése",
    "meeting_tableActions": "Műveletek",
    "door_theNameOfTheTerminal": "Panel neve:",
    "door_deviceID": "Panel azonosítója:",
    "door_Wallpaper": "Háttérkép:",
    "door_Wallpaper_text": "Ajánlott kép: 1280x800 méretben, PNG formátumban",
    "door_bindAMeetingRoom": "Konferenciaterem hozzárendelése:",
    "door_table_name": "Panel neve",
    "door_table_deviceID": "Panel azonosítója",
    "door_table_status": "Állapot",
    "door_table_ipAddress": "IP-cím",
    "door_table_bindAMeetingRoom": "Konferenciaterem hozzárendelése",
    "door_btnAdd": "Hozzáadás",
    "door_btnBatchAdd": "Tömeges hozzáadás",
    "door_btnEdit": "Szerkesztés",
    "door_btnBatchEdit": "Tömeges szerkesztés"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Konfiguráció hozzáadása",
    "configurationEditTitle": "Konfiguráció szerkesztése",
    "dialogConfigName": "Konfiguráció neve",
    "selectNMPAndNDP": "Cél eszközök",
    "powerControl": "Energiaellátás vezérlés",
    "executeCommand": "Tegye",
    "tableConfigName": "Konfiguráció neve",
    "selectConfig": "Kérjük, válassza ki a konfigurációt"
  },
  "NPS": {
    "Relay": "Relé",
    "RelaySettings": "Relé beállítások",
    "DevicePower": "Eszköz energiaellátás vezérlés",
    "DeviceElevation": "Magasság vezérlés",
    "LinageWithNPSPower": "Kapcsolódás az NPS energiával",
    "PresentationSwitch": "Prezentáció kapcsoló",
    "Duplicate": "Másolat",
    "LinkagewithNPSPowe": "Kapcsolódás az NPS energiával"
  },
  "PTZ": {
    "powerSupplyON": "Bekapcsolás",
    "powerSupplyOFF": "Kikapcsolás",
    "LEFT": "BAL",
    "RIGHT": "JOBB",
    "UP": "FEL",
    "DOWN": "LE",
    "HOME": "KÖNYV",
    "ENLARGE": "NAGYÍTÁS",
    "REDUCTION": "KISEBBÍTÉS",
    "StopMovement": "Mozgás leállítása",
    "STOP": "Zoom leállítása",
    "FOCUS": "Fókuszálás",
    "SET_PRESETS0": "ELŐRE BEÁLLÍTÁS0",
    "SET_PRESETS1": "ELŐRE BEÁLLÍTÁS1",
    "SET_PRESETS2": "ELŐRE BEÁLLÍTÁS2",
    "SET_PRESETS3": "ELŐRE BEÁLLÍTÁS3",
    "SET_PRESETS4": "ELŐRE BEÁLLÍTÁS4",
    "SET_PRESETS5": "ELŐRE BEÁLLÍTÁS5",
    "SET_PRESETS6": "ELŐRE BEÁLLÍTÁS6",
    "SET_PRESETS7": "ELŐRE BEÁLLÍTÁS7",
    "SET_PRESETS8": "ELŐRE BEÁLLÍTÁS8",
    "SET_PRESETS9": "ELŐRE BEÁLLÍTÁS9",
    "USE_PRESETS0": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST0",
    "USE_PRESETS1": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST1",
    "USE_PRESETS2": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST2",
    "USE_PRESETS3": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST3",
    "USE_PRESETS4": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST4",
    "USE_PRESETS5": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST5",
    "USE_PRESETS6": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST6",
    "USE_PRESETS7": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST7",
    "USE_PRESETS8": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST8",
    "USE_PRESETS9": "HASZNÁLD AZ ELŐRE BEÁLLÍTÁST9"
  },
  "schedule": {
    "startLinkPowerStart": "Bekapcsolás (CBX relé)",
    "startLinkPowerStop": "Kikapcsolás (CBX relé)",
    "dehumidification": "Száraz",
    "airSupply": "Ventilátor",
    "masterControl": "Fő:",
    "powerSupply": "Áram",
    "lockScreen": "Zár",
    "RecordingControl": "Felvételvezérlés",
    "RecordingControlSystem": "Előadás felvételi rendszer",
    "LiquidCrystal": "Interaktív síkpanel",
    "projector": "Projektor",
    "othertype": "Egyéb",
    "childLock": "Gyermekzár",
    "energySaving": "Energiatakarékos",
    "signalSourceSwitching": "Bemeneti forrás",
    "other": "Egyéb funkciók:",
    "otherFunction": "Funkció",
    "send": "Küldés",
    "ON": "BE",
    "OFF": "KI",
    "btnAddSchedule": "Visszaállítás",
    "EditSchedulelist": "Ütemező szerkesztése",
    "AddSchedulelist": "Ütemező hozzáadása",
    "RestoreSchedulelist": "Visszaállítás",
    "btn": "Mégse",
    "btnNewList": "Új ütemező",
    "ListName": "Név",
    "Cannotquit": "Kötelező",
    "NOCannotquit": "NEM",
    "ListValidityPeriod": "Érvényességi idő",
    "ListDescription": "Leírás",
    "currentSchedule": "Ütemezők listája",
    "historySchedule": "Történeti lista",
    "selectTime": "Idő",
    "taskType": "Feladat típusa",
    "selectBroadcasting": "Közvetítés",
    "selectDeviveControl": "Eszközvezérlés",
    "newSchedule": "Új feladat",
    "newChecklist": "Új ellenőrzőlista",
    "titleStatus": "Állapot",
    "titleType": "Típus",
    "titleStartTime": "Kezdési idő",
    "titleEndTime": "Befejezési idő",
    "titleRepeat": "Ismétlés",
    "titleName": "Név",
    "titleAction": "Művelet",
    "tableEnabled": "Engedélyezett",
    "tablePaused": "Pauszálva",
    "tableEdit": "Szerkesztés",
    "tableDelete": "Törlés",
    "tableVolumeEdit": "Közvetítési hang",
    "tableBroadcastTitle": "Cím",
    "tableBroadcastContent": "Tartalom",
    "tableBroadcastList": "Lista",
    "tableBroadcast": "Kötelező",
    "btnRemoveCompletely": "Teljes eltávolítás",
    "btnEnabled": "Engedélyezett",
    "btnPaused": "Pauszálva",
    "btnDelete": "Törlés",
    "repeat0": "HÉT",
    "repeat1": "KEDD",
    "repeat2": "SZERDA",
    "repeat3": "CSÜT",
    "repeat4": "PÉNTEK",
    "repeat5": "SZOMBAT",
    "repeat6": "VASÁRNAP",
    "dialogTitleAdd": "Új eszközvezérlési feladat",
    "dialogTitleEdit": "Eszközvezérlési feladat szerkesztése",
    "newBroadcastingSchedule": "Új közvetítési feladat",
    "editBroadcastingSchedule": "Közvetítési feladat szerkesztése",
    "chooseDevice": "Eszköz kiválasztása",
    "timeSetting": "Idő beállítása",
    "controlBroadcasting": "Közvetítési opció",
    "controlOption": "Vezérlési opció",
    "scheduleName": "Feladat neve:",
    "destination": "Cél",
    "timeTilte": "Idő",
    "repeatTitle": "Ismétlés",
    "dialogRepeat0": "HÉT",
    "dialogRepeat1": "KEDD",
    "dialogRepeat2": "SZERDA",
    "dialogRepeat3": "CSÜT",
    "dialogRepeat4": "PÉNTEK",
    "dialogRepeat5": "SZOMBAT",
    "dialogRepeat6": "VASÁRNAP",
    "dialogOnceType": "Egyszeri",
    "dialogRepeatType": "Ismétlés",
    "mainPower": "Fő áram",
    "powerControl": "Áramvezérlés",
    "tableDisplayInputSwitch": "Képernyő bemeneti váltó",
    "tableAirConditioning": "Légkondicionáló",
    "tableProjectionScreen": "Vetítővászon",
    "tableElectronicLock": "Elektromos zár",
    "interactiveFlatPanel": "Interaktív síkpanel",
    "displayInputSwitch": "Képernyő bemeneti váltó",
    "speakerVolume": "Hangszóró hangerő",
    "MICVolume": "MIC hangerő",
    "ProjectionScreen": "Vetítővászon",
    "ElectronicLock": "Elektromos zár",
    "AirConditioning": "Légkondicionáló",
    "AirConditioningPower": "Áram",
    "AirConditioningModel": "Modell",
    "AirConditioningTEMP": "HŐMÉRSÉKLET",
    "AirConditioningFanSpeed": "Ventilátor sebesség",
    "OPEN": "NYITÁS",
    "CLOSE": "ZÁRÁS",
    "UP": "FEL",
    "DOWN": "LE",
    "PowerOFF": "KIKAPCSOLÁS",
    "PowerON": "BEKAPCSOLÁS",
    "ModelAuto": "Automatikus",
    "ModelCool": "Hűtés",
    "ModelHeat": "Fűtés",
    "ModelAir": "Légoldali",
    "TEMPLow": "Alacsony",
    "TEMPMiddle": "Közepes",
    "TEMPHigh": "Magas",
    "btnSave": "Mentés",
    "btnNext": "KÖVETKEZŐ",
    "StartTime": "Kezdési idő",
    "StopTime": "Befejezési idő",
    "Mandatory": "Kötelező",
    "Video": "Videó és hang",
    "Notification": "Értesítés",
    "btnFile": "Válasszon egy média fájlt",
    "LastingTime": "Időtartam",
    "textTitle": "Cím",
    "textContent": "Tartalom",
    "textTitleLetters": "Kevesebb, mint 60 karakter",
    "textContentLetters": "Kevesebb, mint 320 karakter",
    "CannotquitYES": "IGEN",
    "CannotquitNo": "Nem",
    "YES": "IGEN",
    "No": "Nem",
    "delTitleContent": "Biztosan törölni akarja ezt az ütemezőt?",
    "delTitleListContent": "A törölt ütemező a történeti listába kerül és visszaállítható",
    "deleListTitle": "Ütemező törlése?",
    "delTitleListContent1": "A törlés a kapcsolódó feladatokat is törli, kérjük, erősítse meg.",
    "deleListTitle1": "Biztosan törölni akarja ezt az ütemezőt?",
    "delTitle": "Törlés?",
    "btnConfirm": "Megerősítés",
    "coxAll": "MIND",
    "coxBroadcasting": "Közvetítés",
    "coxDeviveControl": "Eszköz vezérlés",
    "rdMandatory": "IGEN",
    "noRdMandatory": "Nem",
    "startDate": "Kezdési dátum",
    "endedDate": "Befejezési dátum",
    "or": "-",
    "broadcastingType": "Típus",
    "ChooseTime": "Válassza ki az időt",
    "ChooseDate": "Válassza ki a dátumot",
    "newScheduleList": "Új ütemező",
    "editScheduleList": "Ütemező szerkesztése",
    "listName": "Név",
    "listValidityPeriod": "Érvényességi idő",
    "listDescription": "Leírás",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "restoreSuccess": "Az ütemező lista sikeresen visszaállítva",
    "restoreError": "Az ütemező lista visszaállítása nem sikerült",
    "restoreTitleContent": "Ez az idő ütközik az ütemezett időponttal a listában, kérjük válasszon újat",
    "Enabled": "Engedélyezett",
    "Paused": "Szüneteltetve",
    "Title": "Cím:",
    "Content": "Tartalom:",
    "errorScheduleNameRequired": "A feladat nevét ki kell tölteni",
    "errorDeviceRequired": "Kérjük válassza ki a céleszközt",
    "deleTitle": "Biztosan törölni akarja ezt a feladatot?",
    "loopList": "Ciklus lista",
    "errorPleaseDateRange": "Kérjük válasszon egy dátumtartományt",
    "addError_2009": "Az ütemező neve már létezik",
    "conflicts": "A feladat ideje ütközik a következőkkel:",
    "Pleaseagain": "Kérjük, adja meg újra",
    "errorScheduleName": "Feladat neve",
    "errorListName": "Ütemező neve",
    "today": "Ma",
    "yesterday": "Tegnap",
    "thisWeek": "Ez a hét",
    "lastWeek": "Múlt hét",
    "lastMonth": "Múlt hónap",
    "thisMonth": "Ez a hónap",
    "times": "Idők",
    "TimeConflicts": "Idő ütközés",
    "editError_2006": "Eszköz nem található",
    "editError_2010": "Ismétlődő feladatnév",
    "ListTimeExpired": "Az ütemező ideje lejárt, kérjük válasszon újra",
    "TimeExpired": "Idő lejárt",
    "ControlOption": "Hiányzó vezérlési opció",
    "Pleaseleastone": "Kérjük, válasszon legalább egy vezérlési opciót",
    "Enter": "Belépés",
    "TitleFilled": "A címet ki kell tölteni",
    "ContentFilled": "A tartalmat ki kell tölteni",
    "PleaseMediaFile": "Kérjük válasszon egy média fájlt",
    "PleaseSchedule": "Kérjük válasszon egy feladatot",
    "delTitleScheduleContent": "A törölt feladat nem állítható vissza.",
    "deleTitleSchedule": "Biztosan törölni akarja ezt a feladatot?",
    "deleteScheduleTitle": "Kérjük válasszon ki egy törlendő feladatot",
    "PleaseFillColumn": "Kérjük töltse ki az ütemező nevét",
    "PleaseDate": "Kérjük válassza ki a dátumot",
    "Previous": "Előző",
    "RemoteControl": "Távirányító",
    "taskhasexpired": "Ez a feladat lejárt, kérjük lépjen kapcsolatba a készítővel, hogy frissítse az időpontot.",
    "execute": "Végrehajtás",
    "broadcastingList": "Közvetítési lista",
    "volumeSuccess": "A hangerő sikeresen beállítva",
    "volumeFailed": "A hangerő beállítása nem sikerült"
  },
  "Automation": {
    "nameDuplicate": "Automatikus feladat név ismétlődése",
    "Automation": "Automatizálás",
    "if": "Ha:",
    "ifContent": "A 'HA' szakasz lehetővé teszi feltételek beállítását szenzoradatok alapján. Válassza ki a szenzort és adja meg a feltételeket, például 'Hőmérséklet > 26°C'.",
    "then": "Akkor:",
    "thenContent": "A 'AKKOR' szakasz lehetővé teszi eszközök kiválasztását és műveletek meghatározását számukra. Válasszon olyan eszközöket, mint az NMP1, NMP2, és adja meg a műveleteket, például 'Kapcsolja be + Hűtés' a légkondicionálók számára.",
    "btnDelete": "Törlés",
    "Add": "Hozzáadás",
    "taskName": "Feladat neve",
    "dialogTaskName": "Feladat neve:",
    "Statue": "Állapot",
    "DevicesApplied": "Alkalmazott eszközök",
    "Operation": "Művelet",
    "AirConditioningPower": "Áram",
    "AirConditioningModel": "Modell",
    "AirConditioningFanSpeed": "Ventilátor sebesség",
    "bold": "Lengés",
    "selectTask": "Kérjük, válassza ki a feladatot",
    "autoTaskAdd": "Automatizált feladat hozzáadása",
    "autoTaskEdit": "Automatizált feladat szerkesztése",
    "Destination": "Cél",
    "selectConditions": "Kérjük, adja meg a végrehajtani kívánt műveletet.",
    "selectDestination": "Kérjük, válassza ki a cél NMP eszközt, majd adja meg a végrehajtani kívánt műveletet.",
    "AirConditioningTEMP": "Hőmérséklet",
    "AirConditioningHumidness": "Páratartalom",
    "noData": "Még nincs hozzáadott feladat. Kattintson a \"Hozzáadás\" gombra a feladatok hozzáadásához."
  },
  "rs232Translation": {
    "reliveBinding": "Leválasztás",
    "RELIVEBINDING": "Leválasztás",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "A CBX név nem lehet üres",
    "BrandNoNull": "A márka nem lehet üres",
    "ModelNoNull": "A modell nem lehet üres",
    "AcNoNull": "A légkondicionáló vezérlés nem lehet üres",
    "RcNoNull": "A távirányító nem lehet üres"
  },
  "route": {
    customize: 'Testreszabás',
    "InputSourcesLinkage": "Bemeneti Források Linkelése",
    "Automation": "Automatizálás",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "Csoportok",
    "userMge": "Felhasználók",
    "authorityMge": "Engedélyek",
    "roleMge": "Szerepek",
    "equipmentMge": "Eszközök",
    "workstationMge": "Média Szerver",
    "cloudDiskMge": "Tárolás Kezelés",
    "operationLog": "Műveleti Napló",
    "setting": "Beállítások",
    "resourceMge": "Erőforrás Menedzsment",
    "storageMge": "Tárolás Menedzsment",
    "interfaceRename": "Felület Átnevezése",
    "processorManager": "Processzor Kezelő",
    "projectorCode": "Sorozatszám Menedzsment",
    "projectorCodeSetting": "Sorozatszám Beállítások",
    "RepairLog": "Javítási Napló",
    "remoteControl": "Távirányító Kód",
    "acCode": "A/C Vezérlő Kód",
    "cardMge": "Kártyák",
    "cardLog": "Kártya Használati Napló",
    "cardManager": "Kártya Menedzser",
    "meetingManager": "Találkozó",
    "meetingRoomManager": "Szoba Menedzsment",
    "meetingDoorManager": "Panel Menedzsment"
  },
  "navbar": {
    "logOut": "Kijelentkezés",
    "dashboard": "Irányítópult",
    "screenfull": "Teljes képernyő",
    "language": "Nyelv",
    "userConsole": "Q-NEX Konzol",
    "BackTianwa": "Vissza a Tianwa-ra"
  },
  "feedback": {
    "Feedback": "Visszajelzés",
    "email": "Kérjük, hagyja meg az e-mail címét visszajelzésünkhöz.",
    "content": "Üdvözöljük és hagyja üzeneteit a termékeink fejlesztése érdekében. Köszönjük véleményét.",
    "submit": "Beküldés",
    "emailNoEmpty": "Az e-mail cím nem lehet üres",
    "emailTrueRule": "Kérem, adja meg a helyes e-mail formátumot",
    "contentNoEmpty": "A tartalom nem lehet üres",
    "feedbackSuccess": "Visszajelzés sikeres",
    "feedbackFailed": "Visszajelzés sikertelen",
    "emailNoChinese": "Az e-mail cím nem tartalmazhat kínai karaktereket",
    "emailLength": "5 és 100 karakter közötti hosszúságú",
    "GroupNameLength": "1 és 20 karakter közötti hosszúságú",
    "emailSpecialString": "Ez a szövegdoboz nem tartalmazhat speciális karaktereket"
  },
  "login": {
    "title": "ÜDVÖZÖLJÜK",
    "logIn": "Bejelentkezés",
    "username": "Felhasználónév",
    "password": "Jelszó",
    "any": "bármely",
    "thirdparty": "Vagy csatlakozzon a",
    "thirdpartyTips": "Helyileg nem szimulálható, kérjük, saját üzleti szimulációját kombinálja!",
    "placeholder": "[\n  \"Felhasználónév\",\n  \"Jelszó\",\n  \"Bizonyítvány\"\n]",
    "userNameTitle": "Rossz felhasználónév!",
    "forget": "Elfelejtette?",
    "loginTitle0": "Sikeres bejelentkezés!",
    "loginTitle1000": "Helytelen felhasználónév vagy jelszó!",
    "loginTitle1001": "A felhasználónévnek és jelszónak ki kell töltenie!",
    "loginTitle1002": "A hitelesítési kódot ki kell tölteni!",
    "loginTitle1003": "A felhasználó státusza törvénytelen, bejelentkezés sikertelen!",
    "loginTitle1004": "Hitelesítési kód hiba!",
    "loginTitle1005": "Nincs bejelentkezve, kérjük, jelentkezzen be először!",
    "loginTitleUserName": "Felhasználónevet ki kell tölteni!",
    "loginTitlePwd": "Jelszót ki kell tölteni!",
    "loginTitleVercode": "Hitelesítési kódot ki kell tölteni!",
    "errorLogin": "Nem elegendő felhasználói jogok, nem lehet bejelentkezni!",
    "titleLoginNameFormat": "Karakterekből, vagy karakterekből és számokból kell állnia."
  },
  "organizationMge": {
    "CanTDragTop": "Nem lehet a gyökérbe lépni",
    "prefixCannotBeEmpty": "A szuperadminisztrátor fiók előtagja nem lehet üres",
    "enterEnglishLetters": "A szuperadminisztrátor fiók előtagjában csak angol betűk és számok szerepelhetnek",
    "dateNotSelected": "A streamelési szolgáltatás érvényességi időszakának kezdő dátuma nincs kiválasztva",
    "btnAddChild": "Alárendelt hozzáadása",
    "btnAddSibling": "Testvér hozzáadása",
    "title": "Tipp:",
    "againTitle": "Kérjük, erősítse meg ismét:",
    "sort": "Rendezés:",
    "realName": "Valódi név:",
    "titleShooleRq": "Ezt a mezőt ki kell tölteni",
    "titleShooleNub": "Kevesebb, mint 100 karakter",
    "schoolName": "Csoport neve:",
    "type": "Csoport típusa:",
    "accountPrefix": "Adminisztrátori fiók:",
    "organization": "Terjesztő",
    "terminalMechanism": "Végfelhasználó",
    "equipmentNum": "Eszközkód:",
    "organizationNum": "Terminál csoportok száma:",
    "adminName": "Adminisztrátori fiók:",
    "adminPwd": "Adminisztrátori jelszó:",
    "edit": "Szerkesztés",
    "add": "Hozzáadás",
    "del": "Törlés",
    "addSuccess": "Sikeres hozzáadás",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeresen módosítva",
    "editError": "Módosítás sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delWarn": "Nem törölheti ezt a csoportot, ha eszközökhöz van rendelve",
    "delError": "Törlés sikertelen!",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "TrialWorkstation": "Jelenleg próba állapotban van, amely lehetővé teszi, hogy legfeljebb 3 terminál eszközhöz sugározzon és élő közvetítést végezzen.",
    "Normal": "Normál",
    "NormalWorkstation": "A streamelési szolgáltatás érvényességi ideje",
    "to": "-tól",
    "Advent": "Advent",
    "AdventWorkstationOne": "A streamelési szolgáltatás érvényessége lejár",
    "AdventWorkstationTwo": "-án, kérjük, vegye fel a kapcsolatot a forgalmazójával a frissítés érdekében.",
    "Expired": "Lejárt",
    "ExpiredWorkstation": "A streamelési szolgáltatás lejárt, kérjük, vegye fel a kapcsolatot a forgalmazójával a frissítés érdekében.",
    "admin": "Adminisztrátor:",
    "serviceState": "Streaming média szolgáltatás:",
    "serviceStateLIST": "Streaming média szolgáltatás",
    "ValidityPeriod": "Érvényességi idő:",
    "ValidityPeriodLIST": "Érvényességi idő",
    "Trial": "Próba",
    "Permanent": "Örökös",
    "AnnualBilling": "Éves számlázás",
    "mediaValidityPeriod": "Érvényességi időszak:",
    "mediaValidityPeriodLIST": "Érvényességi időszak",
    "contactInformation": "Kapcsolattartó adatok (A streamelési média szolgáltatás megújítási értesítése)",
    "company": "Cég neve:",
    "email": "E-mail:",
    "phone": "Telefon:",
    "StartDate": "Kezdő dátum",
    "EndDate": "Befejező dátum",
    "To": "#NAME?",
    "TerminalName": "Végfelhasználó neve",
    "Competence": "Adminisztrátor",
    "operate": "Művelet",
    "statusFilter": "Állapot szűrő",
    "disableStreaming": "Biztosan le szeretnéd tiltani a streamelési szolgáltatást?",
    "enableStreaming": "Biztosan engedélyezni szeretnéd a streamelési szolgáltatást?",
    "disableStreamingContent": "Ha a streamelési szolgáltatás le van tiltva, a csoport nem tudja használni a kapcsolódó funkciókat, mint a közvetítés és az élő közvetítés.",
    "enableStreamingContent": "Kérjük, módosítsd az érvényességi időszakot azoknál a csoportoknál, ahol a streamelési szolgáltatás lejárt.",
    "search": "Add meg a szervezet nevét",
    "optionsYearZero": "Kérjük válassz",
    "optionsYearOne": "Egy év",
    "optionsYearTwo": "Két év",
    "optionsYearThree": "Három év",
    "dialogName": "Név:",
    "detTitle": "A csoport törlésével az összes alatta lévő tartalom is törlésre kerül.",
    "groupDelTitle": "Biztosan törölni szeretnéd ezt a csoportot?",
    "delTitle": "Törlés?",
    "delTitleContent": "A kiválasztott tartalmak törlésre kerülnek az adatbázisból. Ez a művelet nem vonható vissza. Biztosan folytatni szeretnéd?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "copySuccess": "A tartalom a vágólapra lett másolva.",
    "copyError": "A böngésző nem támogatja az automatikus másolást",
    "error1200": "Ismétlődő csoportnév",
    "error1201": "Csoport vagy csoport ID ismétlődés",
    "error1202": "Túllépte a csatlakoztatható eszközök maximális számát",
    "error1203": "Ismétlődő felhasználónév",
    "error1204": "Van egy csoport ugyanazzal a névvel ugyanazon a szinten",
    "error1210": "Kérjük, add meg az adminisztrátor jelszót",
    "warningGroup": "Válassz egy csoportot!",
    "warningTerminal": "A terminálcsoport nem hozhat létre almappákat!",
    "account": "Ismétlődő fiók",
    "titleOrganization": "Megjegyzés: A fiókelőtag a szervezeti szinten van meghatározva. A szervezeten belüli összes felhasználói fiók ugyanazt az előtagot fogja használni.",
    "all": "Minden"
  },
  "userMge": {
    "nickName": "Becenév",
    "contentWithBrand": "Írd be a márkát vagy modellt",
    "contentwithIp": "Keresés eszköz név vagy IP cím alapján.",
    "btnAdd": "Új felhasználó",
    "btnDelete": "Törlés",
    "btnDownload": "Sablon letöltése",
    "btnImport": "Tömeges importálás",
    "btnExport": "Letöltés",
    "btnDisable": "Letiltás",
    "btnEnable": "Engedélyezés",
    "accountType": "Szerepkör szerinti szűrés",
    "organizationName": "Csoport szerinti szűrés",
    "content": "Keresés",
    "systemAccount": "Felhasználói ID",
    "idCardNumber": "Munkavállalói ID",
    "customizeAccount": "Testreszabott fiók",
    "userName": "Név",
    "licenseNum": "Licensz szám",
    "phone": "Telefon",
    "email": "E-mail",
    "role": "Szerepkör",
    "status": "Állapot",
    "affiliatedOrganization": "Csoportok",
    "roleTypeList1": "Általános felhasználó",
    "roleTypeList2": "Diák",
    "roleTypeList3": "Szülő",
    "roleTypeList101": "Ügynöki adminisztrátor",
    "roleTypeList102": "Adminisztrátor",
    "roleTypeList301": "Szuper adminisztrátor",
    "userStatus1": "Aktív",
    "userStatus2": "Letiltott",
    "userStatus3": "Törlés",
    "operate": "Műveletek",
    "dialogName": "Becenév:",
    "dialogUserName": "Felhasználói ID:",
    "dialogUserNameDefined": "Felhasználónév:",
    "dialogPassword": "Jelszó:",
    "dialogID": "Munkavállalói ID:",
    "dialogRole": "Szerepkör:",
    "dialogEmail": "E-mail:",
    "dialogPhone": "Telefon:",
    "dialogGroup": "Csoport:",
    "addUser": "Új felhasználó",
    "editUser": "Felhasználó szerkesztése",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "tableDel": "Törlés",
    "tableEdit": "Szerkesztés",
    "selectRoles": "Szerepkörök kiválasztása",
    "delTitle": "Törlés?",
    "delTitleContent": "A kiválasztott tartalmak törlésre kerülnek az adatbázisból. Ez a művelet nem vonható vissza. Biztosan folytatni szeretnéd?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "titleRealNameRq": "Ez a mező kötelező",
    "titleRealNameFormat": "Válassz felhasználónevet, ami csak betűket és számokat tartalmaz.",
    checkPasswordTitleTwo: 'Kérjük, állítson be legalább 6 karakter hosszú jelszót, amely betűket és számokat tartalmaz. Speciális karakterek használata engedélyezett (korlátozás nélkül).',
    checkPasswordTitle: 'A jelszónak legalább 6 karakterből kell állnia, és nem lehet csak számokból',
    "titlePhoneFormat": "A telefon csak számokat, () + és - jeleket tartalmazhat.",
    "phoneFilled": "A telefont kötelező kitölteni.",
    "titleEmaileFormat": "Hibás e-mail formátum.",
    "emaileFilled": "Az e-mail kötelező.",
    "titlUserNameDefinedNub": "A felhasználónév nem haladhatja meg a 30 karaktert",
    "titlRealNameNub": "A név nem haladhatja meg a 30 karaktert.",
    "titlRealNameField": "A név kötelező.",
    "thisPasswordField": "A jelszót kötelező megadni.",
    "titlPassWordNub": "A jelszónak 6~30 karakter között kell lennie.",
    "enableStatus": "Felhasználó engedélyezése",
    "stopStatus": "Felhasználó letiltása",
    "enableContent": "Biztosan engedélyezni szeretnéd a felhasználót(okat)?",
    "stopContent": "Biztosan le szeretnéd tiltani a felhasználót(okat)?",
    "error1400": "A felhasználónév már létezik, kérlek próbáld újra",
    "error1401": "A felhasználói ID már létezik, a művelet nem sikerült!",
    "error1402": "A csoport nem létezik, az importálás nem sikerült!",
    "error1403": "Hibás adat",
    "error1404": "Nem elegendő jogosultság",
    "selUser": "Kérlek válassz egy felhasználót!",
    "error1405": "Nem sikerült a szerepkör lekérése",
    "error1406": "A beimportált felhasználói információk adatformátuma hibás",
    "error1407": "Az e-mail már létezik, a művelet nem sikerült.",
    "error1408": "A telefon már létezik, a művelet nem sikerült.",
    "error1900": "A hozzáfért paraméter üres",
    "error1610": "Kérlek használd a terminál adminisztrátori szerepkörét a kapcsolódó műveletekhez",
    "errorOrgIdList": "A csoport nem lehet üres!",
    "Bindsucceeded": "Hozzáadás sikerült",
    "Bindfailed": "Hozzáadás nem sikerült",
    "tableuserName": "Felhasználónév",
    "titleDevice": "Eszköz",
    "bindDevice": "Eszköz hozzáadása",
    "Bindcontrollable": "Hozzáadni a vezérelhető eszközt most?"
  },
  "devicesMge": {
    mustChooseOne: 'Amikor az intelligens távirányító be van jelölve, legalább egy vezérlőparancsot ki kell választani',
    customName: 'Egyéni név',
    "testAcCode": "Új A/C vezérlő kód tesztelése",
    "Online": "Online",
    "Offline": "Offline",
    "unBindConfirm": "Megerősíti, hogy le szeretné választani az Serial-t?",
    "unBindConfirm485": "Megerősíti, hogy le szeretné választani az RS485-t?",
    "notYetBoundRS232": "A készülékhez még nincs hozzárendelve Serial kód. Az Serial vezérlő kódot a Készülék > Serial Vezérlő Kód menüpontban adhatja hozzá.",
    "RsFollowingFunctions": "Serial kódok segítségével az alábbi funkciók érhetők el:",
    "Unbind": "Leválasztás",
    "Limit255": "A fájlnév legfeljebb 255 karakterből állhat",
    "clear": "Törlés",
    "equipName": "Eszköz neve",
    "equipType": "Típus",
    "selectField": "Kérjük válasszon fájlt",
    "dialogTip": "*Ha a jobb oldali beviteli mező üres, akkor alapértelmezetten a bal oldali tartalom jelenik meg",
    "dialogTipSingle": "*Ha egy eszközt nem neveztek el, akkor az \"ÖSSZES\" név szerint történik",
    "cantDelTemplateOne": "A(z) CBX-e",
    cantDelTemplateTwo: 'A(z) "{deviceName}" eszköz CBX-e sablon. Biztosan törölni szeretné?',
    "templateTitle": "Sablon csere",
    "templateContentOne": "A(z) eszköz neve \"",
    "templateContentTwo": "\" a közös CBX sablonként lett beállítva. Biztosan szeretné az aktuális eszközt sablonként beállítani?",
    "vcbNoTemplateNoSave": "Nem lehet menteni sablon nélkül",
    "vcbAcControl": "Válasszon egy A/C eszközt",
    "vcbRemoteControl": "Válasszon egy távirányító eszközt",
    "vcbPOWERControl": "Áramellátás vezérlés",
    "vcbRS232Control": "Serial vezérlés",
    "vcbIRControl": "IR vezérlés",
    "vcbSetting": "CBX beállítás",
    "editVcb": "CBX szerkesztése",
    "vcbName": "CBX név",
    "iot": "CBX vezérlés",
    "saveAsTemplate": "Mentés sablonként",
    saveAsTemplatereplenish: 'Válasszon ki több eszközt a sablon használatához a Vezérlőközpontban',
    "Upload": "Feltöltés",
    "Select": "Választás",
    "InputDeviceID": "Eszköz ID megadása",
    "editNameTips": "* Ha a jobb oldali beviteli mező üres, akkor a bal oldalon lévő tartalom jelenik meg alapértelmezettként.",
    "_RS232A": "Első interfész",
    "_RS232B": "Második interfész",
    "institutionDirectory": "Intézményi könyvtár",
    "projectionScreenLinkageSetting": "Projektor képernyő vezérlés beállítása",
    "screenLiftingLinkageDisplaySwitch": "Projektor képernyő és kijelző összekapcsolt vezérlése:",
    "stopLinkage": "Letiltás (A projektor képernyő vezérlése külön)",
    "Enable": "Engedélyezés (A projektor képernyő és kijelző szinkron vezérlése)",
    "btnAddDevice": "Eszköz hozzáadása",
    "btnImportDevice": "Tömeges eszköz importálása",
    "btnDel": "Törlés",
    "btnEdit": "Szerkesztés",
    "tableIpAddress": "IP cím",
    "MACAddress": "MAC-cím",
    "firmwareVersion": "Firmware verzió",
    "NA": "N/A",
    "tableDeviceName": "Eszköz neve",
    "tableStatus": "Állapot",
    "tableVideoSwitch": "Videó kapcsoló",
    "tableAudio": "A/V elosztás",
    "tablePowerControl": "Tápegység vezérlés",
    "tableRS232": "Sorozatszám vezérlés",
    "tableIR": "IR vezérlés",
    "tableRFIDCard": "IC kártya",
    "tableControlPanel": "Vezérlő panel",
    "tableOrganization": "Csoportok",
    "tableActions": "Műveletek",
    "dialogAddTitle": "Eszköz hozzáadása",
    "dialogEditTitle": "Eszköz szerkesztése",
    "dialogBatchAddTitle": "Tömeges eszköz hozzáadása",
    "dialogBatchEditTitle": "Tömeges szerkesztés",
    "btnCancel": "Mégse",
    "Devices": "Eszközök:",
    "ProjectorCode": "Serial kód:",
    "Group": "Csoport:",
    "btnBatchAdd": "Tömeges hozzáadás",
    "delTitle": "Törlés?",
    "delTitleContent": "A kiválasztott összetevőket töröljük az adatbázisból. Ez a folyamat nem visszafordítható. Biztosan folytatni szeretné?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "addError": "Hozzáadás nem sikerült!",
    "editSuccess": "Szerkesztés sikeres!",
    "editError": "Szerkesztés nem sikerült!",
    "delSuccess": "Törlés sikeres!",
    "delError": "Törlés nem sikerült!",
    "content": "Keresés",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "tableDel": "Törlés",
    "tableEdit": "Szerkesztés",
    "selectRoles": "Szerepek kiválasztása",
    "selectType": "Kérjük válasszon típust",
    "selectDevices": "Kérjük válasszon egy eszközt",
    "titleRealNameRq": "Ez a mező kötelező",
    "titleRealNameNub": "Kevesebb, mint 100 karakter",
    "titlPassWordNub": "Kevesebb, mint 15 karakter",
    "error1900": "A hozzáfért paraméter üres",
    "error2000": "Túl lépte a csatlakoztatható eszközök maximális számát",
    "error2001": "A importált eszközkód helytelen vagy még nem lett felvéve a rendszerbe",
    "error2002": "Ismétlődő eszköznév importálása",
    "error2003": "Az importált eszköz ID már használatban van",
    "error2004": "Importált adat hiba",
    "error2005": "A márka vagy modell neve megegyezik a rendszerben már meglévő adatokkal; kérjük, nevezze át a márkát vagy modellt.",
    "error2008": "Ez az eszköz már egy másik csoporthoz van rendelve",
    "notDevicesName": "Az eszköz neve nem lehet üres",
    "notDevicesNO": "Az eszköz ID nem lehet üres",
    "dialogDevicesName": "Eszköz neve:",
    "dialogDevicesID": "Eszköz ID:",
    "dialogProjectorCode": "Serial kód:",
    "dialogGroup": "Csoport:",
    "dialogSel": "Kérem válasszon",
    "errorOrgIdList": "A csoport nem lehet üres!",
    "errorDevicesName": "Az eszköz neve nem lehet üres!",
    "errorDevicesNo": "Az eszköz ID nem lehet üres!",
    "dialogTiltleDevices": "Eszközök:",
    "uploadSuccess": "Feltöltés sikeres",
    "addSuccess": "Hozzáadás sikeres",
    "ChooseGroups": "Csoportok kiválasztása",
    "ChooseIcon": "Ikon kiválasztása",
    "dialogDevicesTitle": "A paraméterbeállítások az alábbi eszközökre vonatkoznak",
    "backDevice": "Vissza",
    "bootSetting": "Indítási beállítások",
    "nmpOpenSetting": "Bekapcsolási beállítások",
    "npsOpenSetting": "Bekapcsolási beállítások",
    "nmpPowerSettings": "Energiagazdálkodás beállítások",
    "npsPowerSettings": "Energiagazdálkodás beállítások",
    "nmpInterfaceSettings": "Interfész beállítások",
    "npsInterfaceSettings": "Interfész beállítások",
    "nmpDefaultChannel": "Alapértelmezett csatorna beállítások",
    "nmpCloseSetting": "Kikapcsolási beállítások",
    "npsCloseSetting": "Kikapcsolási beállítások",
    "SwipeToStart": "Zár engedélyezése (Kártya érintésével feloldás)",
    "ControlPanelToStart": "Zár letiltása (Korlátlan művelet)",
    "Display": "Kijelző",
    "External": "Külső",
    "startingUpMethod": "Panelzár engedélyezése/letiltása:",
    "startWith": "Indulás:",
    "nmpstartWith": "Szinkron bekapcsolás:",
    "nmpcloseWith": "Szinkron kikapcsolás:",
    "RS232Tip": "Amikor a fő áram ki van kapcsolva, összesen 5 Serial interfész, beleértve az Serial-t és legfeljebb 4 CBX-t, megkapja a megfelelő leállítási parancskódot",
    startPowerTip: 'Bekapcsoláskor az összes CBX tápcsatlakozóra kötött eszköz egyszerre kapcsol be.',
    startAirTip: 'Bekapcsoláskor az összes hozzárendelt klíma egység egyszerre kapcsol be az eszköz/CBX infravörös jelével.',
    startIrTip: 'Bekapcsoláskor az eszköz/CBX infravörös jelén keresztül parancsot küld (pl. vetítővászon leengedése, projektor bekapcsolása).',
    startRSTip: 'Bekapcsoláskor az eszköz/CBX Serial portján keresztül bekapcsolási parancsot küld.',
    CloseDisplayTip: 'A DISPLAY csatlakozóra kötött eszközök automatikusan kikapcsolnak, amikor az NDP/NMP kikapcsol. Ezt a beállítást a firmware kezeli, és nem módosítható szoftverrel.',
    CloseExternalTip: 'Az EXTERNAL csatlakozóra kötött eszközök automatikusan kikapcsolnak, amikor az NDP/NMP kikapcsol. Ezt a beállítást a firmware kezeli, és nem módosítható szoftverrel.',
    ClosePowerTip: 'Kikapcsoláskor az összes CBX tápcsatlakozóra kötött eszköz egyszerre kikapcsol.',
    CloseAirTip: 'Kikapcsoláskor az összes hozzárendelt klíma egység egyszerre kikapcsol az eszköz/CBX infravörös jelével.',
    CloseIrTip: 'Kikapcsoláskor az eszköz/CBX infravörös jelén keresztül parancsot küld (pl. vetítővászon felhúzása, projektor kikapcsolása).',
    CloseRSTip: 'Kikapcsoláskor az eszköz/CBX Serial portján keresztül kikapcsolási parancsot küld.',
    npsOpenRS232Tip: 'Amikor a főtápegység be van kapcsolva, az NPS két soros portja megkapja a megfelelő bekapcsolási parancskódokat.',
    "npsRS232Tip": "Amikor a fő áram ki van kapcsolva, az NPS két Serial interfésze megkapja a megfelelő leállítási parancskódokat.",
    "useCardTip": "Kártya feloldása után az eszközök áramellátása automatikusan aktiválódik.",
    "npsCardTip": "Kártya feloldása után az eszközök fő áramellátása automatikusan aktiválódik.",
    "PowerOutageHandling": "Áramkimaradás kezelése",
    "PowerOutageHandTip": "Az áramkimaradások során történő folyamatos hozzáférés érdekében válassza a 'Feloldás áramkimaradáskor' lehetőséget. Ellenkező esetben válassza a 'Zár áramkimaradáskor' lehetőséget a hozzáférés korlátozásához.",
    "acSetting": "A/C beállítások",
    "ChooseType": "Eszköztípus",
    "ChooseBrand": "Válasszon egy márkát",
    "ChooseModel": "Válasszon egy modellt",
    "btnConnectingTest": "Kapcsolódási teszt",
    "LockSetting": "Elektromos zár beállítás",
    "ElectricLockType": "Elektromos zár típusa:",
    "PowerUNLOCK": "Feloldás áramkimaradáskor",
    "PowerLOCK": "Zár áramkimaradáskor",
    "none": "Nincs",
    "oddParity": "Páratlan paritás",
    "EvenParity": "Páros paritás",
    "LastSetting": "Utolsó beállítás",
    "ElectricLockClosing": "Elektromos zár zárása:",
    "manualSwitch": "Manuális kapcsoló",
    "Auto": "Automatikus (in)",
    "projectorSetting": "Eszközkiválasztás és kötés",
    "baudRate": "Baud sebesség",
    "Parity": "Paritás",
    "ON": "BEMUTATÁS",
    "OFF": "KIKAPCSOLÁS",
    "Channel1": "1. csatorna",
    "Channel2": "2. csatorna",
    "PowerOffDelay": "Késleltetés kikapcsolás",
    "second": "s",
    "DefaultChannel": "Alapértelmezett csatorna",
    "HDMIA": "HDMI kimenet A:",
    "HDMIB": "HDMI kimenet B:",
    "HDMIC": "HDMI kimenet C:",
    "btnSaveApply": "Mentés és alkalmazás...",
    "btnSave": "Mentés",
    "btnCustomize": "Egyedi",
    "ACIsPowerTitle": "Ellenőrizze, hogy a légkondicionáló be van-e kapcsolva?",
    "ACIsPowerContent": "Kérjük, kapcsolja ki a légkondicionálót tesztelés előtt. Ha nem kapcsolódik be sikeresen, kérjük, ellenőrizze, hogy a légkondicionáló márkája és modellje helyes-e.",
    "btnNextModel": "Nem, tesztelje a következő modellt",
    "btnYes": "Igen",
    "errorConnecting": "Csatlakozási teszt sikertelen",
    "hot": "FORRÓ",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "IR vezérlés beállítások",
    "acControlTitle": "Válasszon egy légkondicionáló eszközt:",
    "acControlTitleNew": "Légkondicionáló eszköz",
    "intelligentControlTitle": "Válasszon egy távirányító eszközt:",
    "intelligentControlTitleNew": "Távirányító eszköz",
    "btnACControlCode": "Új légkondicionáló vezérlő kód azonosítása",
    "btnAddRemoteControl": "Új távirányító kód",
    "ACControlCodeTitle": "Légkondicionáló vezérlő kód azonosítása",
    "ACControlCodeseft1": "Kód azonosítása",
    "ACControlCodeseft2": "Információ hozzáadása",
    "btnStartIdentify": "Indítás",
    "Identifysuccess": "Sikeres azonosítás!",
    "BeingIdentify": "Elemzés...",
    "acBrand": "Légkondicionáló márka",
    "acModel": "Légkondicionáló modell",
    "IdentifyFailureTitle": "Nem sikerült megtalálni a kódot",
    "IdentifyFailureContent": "Az azonosítás nem sikerült, ez a modell jelenleg nem támogatott. Kérjük, próbálja meg a távirányítót",
    "btnTryAgain": "Próbálja újra",
    "btnJump": "Menjen a távirányítóra",
    "ACrideo": "Légkondicionáló",
    "ortherRideo": "Egyéb eszközök",
    "btnBack": "Vissza",
    "btnSortOut": "Szerkesztéshez",
    "remoteControlSeft1": "Eszköztípus kiválasztása",
    "remoteControlSeft2": "Kód tanulása",
    "remoteControlSeft3": "Információ hozzáadása",
    "addRemoteControlError": "Sajnálom, nem lehet több kódot tanulni. Kérjük, először szerkessze a meglévő távirányító kódokat",
    "btnPrevious": "Előző",
    "btnNextStep": "Következő",
    "remoteControlErrorTitle": "A kód tanulása nem sikerült",
    "remoteControlErrorContent1": "1. Az infravörös adó nincs blokkolva",
    "remoteControlErrorContent2": "2. Nincs erős fény zavaró hatása a vevő körül",
    "remoteControlErrorContent3": "3. Az infravörös adó megfelelően van telepítve",
    "remoteControlErrorContent4": "4. A távirányító jól működik",
    "deviceItem1": "Légkondicionáló",
    "deviceItem2": "Projektor",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilátor",
    "deviceItem5": "Fény",
    "deviceItem6": "Egyéb",
    "deviceItem7": "Interaktív síkpanel",
    "deviceItem8": "Előadás rögzítő rendszer",
    "deviceItem9": "PTZ kamera",
    "RS232protocol": "Serial protokoll:",
    "btnRemoteControl": "Kezdje el tanulni",
    "BeingIdentify1": "Elemzés...",
    "Identifysuccess1": "Siker",
    "controllerType1": "Légkondicionáló",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilátor",
    "controllerType5": "Fény",
    "controllerType9": "Egyéb",
    "rqRemoteControlCode": "Kérem, adja meg a távirányító kód nevét",
    "rqBrand": "Kérem, adja meg a légkondicionáló márkáját",
    "rqModel": "Kérem, adja meg a légkondicionáló modelljét",
    "error2016": "A távirányító neve duplikálódott, kérjük, adjon meg egy másikat",
    "RS232Setting": "Soros kód beállítása",
    "IR232Setting": "IR beállítások",
    "SystemError": "Rendszerhiba. Kérjük, próbálja újra",
    "conditionerCodeContent": "Nem található a légkondicionáló kódja, kérjük, próbálja újra",
    "remoteControlCodeContent": "Nem található a távirányító kódja, kérjük, próbálja újra",
    "btnRetry": "Próbálja újra",
    "Bindusers": "Felhasználó hozzárendelése",
    "tablebinduser": "Felhasználók hozzárendelése",
    "Refresh": "Frissítés",
    "Binduserlable": "Hozzárendelni a felhasználókat, akik most vezérelhetik az eszközt?",
    "SaveApplySuccessfully": "Sikeresen mentés és alkalmazás",
    "DeviceType": "Típus:",
    "tableDeviceType": "Típus",
    "empty": "Üres.",
    "sendCommand": "Küldés később",
    "enable": "Engedélyezés",
    "disable": "Letiltás",
    "SYNCremoteControl": "SZINKRONIZÁLÁS távirányítóval",
    "analysisfailed": "Az elemzés nem sikerült, kérjük, próbálja újra!",

    "CBX": {
      "powerSupplyON": "Bekapcsolás",
      "powerSupplyOFF": "Kikapcsolás",
      "powerVcrON": "Felvétel indítása",
      "powerVcrOFF": "Felvétel leállítása",
      "lockScreenON": "Zár bekapcsolás",
      "lockScreenOFF": "Zár kikapcsolás",
      "childLockON": "Gyerekzár bekapcsolás",
      "childLockOFF": "Gyerekzár kikapcsolás",
      "energySavingON": "Energiatakarékos mód bekapcsolás",
      "energySaving": "Energiatakarékos mód",
      "energySavingOFF": "Energiatakarékos mód kikapcsolás",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Hangszóró",
      "brightAdjustment": "Fényerő",
      "other": "Egyéb funkciók...",
      "volumeExample": "Teljes Serial vezérlő funkciók szükségesek a felvételi rendszer teljes kompatibilitásához.",
      "functionCode": "Funkció:",
      "Name": "Név:",
      "controlCode": "Vezérlő kód:",
      "brand": "Márka:",
      "model": "Modell:",
      "errorBrandName": "A márka nem lehet üres!",
      "errorModelName": "A modell nem lehet üres!"
    }
  },
  "roleMge": {
    "role1": "Általános felhasználó",
    "role101": "Ügynöki adminisztrátor",
    "role102": "Adminisztrátor",
    "role4": "Egyéni szerep",
    "roleNew": "Új szerep",
    "btnAddRole": "Szerep hozzáadása",
    "chooseUser": "Válassza ki a felhasználót",
    "titleLevel": "Közvetítés tulajdonsági szint:",
    "titleSettings": "Engedélyek beállítása:",
    "btnSave": "Mentés",
    "btnDelete": "Törlés",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "addSuccess": "Hozzáadás sikerült!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Szerkesztés sikerült!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Törlés sikerült!",
    "delError": "Törlés sikertelen!",
    "V3_0_OrganizationManage": "Csoportkezelés",
    "V3_0_UserManage": "Felhasználók kezelése",
    "V3_0_DeviceManage": "Eszközök kezelése",
    "V3_0_CloudSpaceManage": "Felhő tároló kezelés",
    "V3_0_OrganizationManage_View": "Nézet",
    "V3_0_OrganizationManage_Edit": "Szerkesztés",
    "V3_0_UserManage_View": "Nézet",
    "V3_0_UserManage_Edit": "Szerkesztés",
    "V3_0_DeviceManage_AddDevice": "Eszköz hozzáadása",
    "V3_0_DeviceManage_Operating": "Működés",
    "V3_0_DeviceManage_Delete": "Törlés",
    "V3_0_DeviceManage_Edit": "Szerkesztés",
    "V3_0_CloudSpaceManage_PersonalManage": "Személyes felhőkezelés",
    "V3_0_CloudSpaceManage_PublicManage": "Nyilvános felhőkezelés",
    "V3_0_CloudSpaceManage_SpaceManage": "Tárhely hozzárendelés",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Működés",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Nézet",
    "V3_0_CloudSpaceManage_PublicManage_View": "Nézet",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Feltöltés",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Letöltés",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Fájl törlése",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Mappa szerkesztése",
    "delTitle": "Törlés?",
    "delTitleContent": "A kiválasztott tartalom törlésre kerül az adatbázisból. Ez a művelet nem vonható vissza. Biztos benne, hogy folytatni szeretné?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "btnAdd": "Szerep hozzáadása",
    "RoleName": "Szerep neve:",
    "ManageRange": "Kezelési terjedelem:",
    "ChooseUser": "Válassza ki a felhasználót:",
    "PermissionSettings": "Engedélyek beállítása:",
    "BroadcastingPropertyLevel": "Közvetítés tulajdonsági szint",
    "ChooseGroups": "Válassza ki a csoportokat",
    "ChooseTheUser": "Válassza ki a felhasználót",
    "deleleTitle": "Az új szerep nincs elmentve. Ha elhagyja, a szerep törlődni fog. Biztosan el akarja hagyni?",
    "Error1601": "Nem használható adminisztrátori szerepként",
    "Error1602": "Engedély szerep megszerzése sikertelen",
    "Error1603": "Csak az adminisztrátorok férhetnek hozzá ilyen funkciókhoz",
    "Error1604": "A szerep neve nem lehet üres",
    "Error1605": "A csoport nem lehet üres",
    "Error1606": "Ez a szerep már létezik",
    "Error1607": "Rendszer által definiált szerep, módosítás nem engedélyezett",
    "Error1608": "Szerep beállítása sikertelen",
    "Error1609": "Rendszer által definiált közönséges felhasználói szerep, módosítás nem engedélyezett",
    "Error1610": "Kérjük, használja a terminál adminisztrátori szerepét a kapcsolódó műveletekhez",
    "Error1611": "Nincs kapcsolódó szerep engedély"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Töltse ki a funkció nevét és a vezérlőkódot. A vezérlőkód példák HEX formátumot használnak.",
    "tipTwo": "2. Ez a felület csak a be-/kikapcsolási soros parancsok konfigurációjára szolgál. A funkció engedélyezéséhez lépjen a 'Eszközkezelés / Eszközök / Műveletek / Tápellátás beállításai' menüpontra.",
    "tipFunctionOne": "1. Válassza ki a gyakori funkciókat a legördülő listából. A megfelelő ikonok megjelennek az intelligens panel soros vezérlőfelületén.",
    "tipFunctionTwo": "2. A 'POWER ON' és 'POWER OFF' parancsok az eszköz be-/kikapcsolási soros összekapcsolására szolgálnak. Ez az oldal csak vezérlőkódokat konfigurál. Az összekapcsolási funkció engedélyezéséhez lépjen a 'Eszközkezelés / Eszközök / Műveletek / Tápellátás beállításai' menüpontra.",
    "ListRS232functions": "Sorozatvezérlő funkciók listája",
    "Customizefunctionlist": "Testreszabás a funkciók listájához",
    "btnAddProjectorCode": "Sorozatszám hozzáadása",
    "btnDel": "Törlés",
    "inputSeach": "Keresés",
    "btnEdit": "Szerkesztés",
    "cancel": "Tisztítás",
    "confirm": "Megerősítés",
    "tableName": "Kód neve",
    "tablersType": "Eszköztípus:",
    "tablersTypeTable": "Eszköztípus",
    "tableModel": "Modell",
    "tableBrand": "Márka",
    "tableActions": "Műveletek",
    "dialogAddTitle": "Serial kód hozzáadása",
    "dialogEditTitle": "Serial kód szerkesztése",
    "brand": "Márkanev:",
    "model": "Modell:",
    "baudRate": "Bites sebesség:",
    "parity": "Párosítás:",
    "powerOn": "Be",
    "powerOff": "Ki",
    "pgrInput1": "Csatorna 1",
    "pgbInput2": "Csatorna 2",
    "delTitle": "Törlés?",
    "delTitleContent": "A kijelölt tartalmak törlésre kerülnek az adatbázisból. Ez az művelet nem visszavonható. Biztos benne, hogy folytatja?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "content": "Keresés",
    "operate": "Műveletek",
    "tableDel": "Törlés",
    "tableEdit": "Szerkesztés",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "selectTitle": "Kérjük, válasszon egy Serial-t!",
    "selectCode": "Serial kiválasztása",
    "none": "Nincs",
    "oddParity": "Páratlan párosítás",
    "EvenParity": "Páros párosítás"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Csoportkezelés",
    "V3_0_UserManage": "Felhasználókezelés",
    "V3_0_DeviceManage": "Eszközkezelés",
    "V3_0_CloudSpaceManage": "Felhőtárhely-kezelés",
    "V3_0_OrganizationManage_View": "Megtekintés",
    "V3_0_OrganizationManage_Edit": "Szerkesztés",
    "V3_0_UserManage_View": "Megtekintés",
    "V3_0_UserManage_Edit": "Szerkesztés",
    "V3_0_DeviceManage_AddDevice": "Eszköz hozzáadása",
    "V3_0_DeviceManage_Operating": "Működtetés",
    "V3_0_DeviceManage_Delete": "Törlés",
    "V3_0_DeviceManage_Edit": "Szerkesztés",
    "V3_0_DeviceManage_RepairLog": "Javítási napló",
    "V3_0_CloudSpaceManage_PersonalManage": "Személyes felhőkezelés",
    "V3_0_CloudSpaceManage_PublicManage": "Nyilvános felhőkezelés",
    "V3_0_CloudSpaceManage_SpaceManage": "Felhőtárhely-kezelés",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Működtetés",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Megtekintés",
    "V3_0_CloudSpaceManage_PublicManage_View": "Megtekintés",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Feltöltés",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Letöltés",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Törlés",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Szerkesztés",
    "delTitle": "Törlés?",
    "delTitleContent": "A kiválasztott összetevők törlésre kerülnek az adatbázisból. Ez a művelet visszafordíthatatlan. Biztosan folytatni szeretné?",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "content": "Keresés",
    "operate": "Akció",
    "tableDel": "Törlés",
    "tableEdit": "Szerkesztés",
    "addSuccess": "Hozzáadás sikeresen!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Szerkesztés sikeresen!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Törlés sikeresen!",
    "delError": "Törlés sikertelen!",
    "selectTitle": "Kérjük, válasszon Serial-t!"
  },
  "workstationMge": {
    "priorChoice": "Adás Preferencia:",
    "SpeedPriority": "Sebesség prioritás",
    "SyncPriority": "Képfrissítés szinkronizálás prioritás",
    "SpeedPriorityTip": "Miután az AV adás utasításokat elküldték, a Q-NEX terminálok körülbelül 3-5 másodperces pufferidővel képesek végrehajtani a lejátszási feladatot. A sebesség prioritás erősen ajánlott, ha a Media Server LAN hálózaton működik.",
    "SyncPriorityTip": "Miután az AV adás utasításokat elküldték, a Q-NEX terminálok szinkronizáltan hajtják végre a lejátszási feladatot körülbelül 8-12 másodperces pufferidővel.",
    "btnAddMedia": "Média szerver hozzáadása",
    "btnBack": "Vissza",
    "tableMediaLibId": "Média szerver azonosító",
    "tableMediaLibName": "Média szerver neve",
    "tableState": "Hálózati állapot",
    "tableBindingUsers": "Felhasználók kötése",
    "tableLiveAddress": "Streaming cím",
    "tableAddress": "Adás cím",
    "tableOperate": "Műveletek",
    "tableDel": "Törlés",
    "tableEdit": "Szerkesztés",
    "titleMediaStation": "Adás cím",
    "titleLiveStation": "Streaming cím:",
    "radioPublic": "Nyilvános",
    "radioPrivate": "Privát",
    "btnSave": "Mentés",
    "titleUsers": "Felhasználók",
    "titleCanBe": "Köthető",
    "titleHaveBeen": "Már kapcsolódott",
    "titleMore": "Szükséges több hozzáadása?",
    "btnAdd": "Hozzáadás",
    "content": "Keresés",
    "tableName": "Név",
    "tableUserName": "Felhasználónév",
    "operate": "Műveletek",
    "affiliatedOrganization": "Csoportok",
    "dialogTitle": "Új média szerver hozzáadása",
    "dialogTitleEdit": "Új média szerver szerkesztése",
    "dialogItemName": "Név:",
    "dialogItemId": "Azonosító:",
    "dialogItemIp": "Adás cím:",
    "titleSelectUsers": "Felhasználók kiválasztása",
    "selectMedia": "Kérem, válasszon médiát",
    "delTitle": "Biztosan törölni szeretné?",
    "delMediaLibTitle": "Törlés megerősítése?",
    "delTitleContent": "A kiválasztott tartalmak törlésre kerülnek az adatbázisból. Ez a művelet nem vonható vissza. Biztosan folytatni szeretné?",
    "delTitleMediaLibContent": "A törlési művelet a kapcsolódó adatokat törli, és nem lehet visszavonni.",
    "delCancelButton": "Mégse",
    "delConfirmButton": "Megerősítés",
    "selectDevices": "Kérem, válasszon eszközöket",
    "selectUser": "Kérem, válasszon felhasználókat",
    "addUser": "Felhasználó hozzáadása",
    "editUser": "Felhasználó szerkesztése",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "error2500": "A munkamenethez csatlakoztatható eszközök maximális számát meghaladta.",
    "DeviceName": "Eszköz neve",
    "AssociatedUserManagement": "Kapcsolódó felhasználók kezelése",
    "btnDel": "Törlés",
    "errorMsgId": "Nem található ez az ID",
    "LiveStreaming": "Streaming cím:",
    "NoFoundMediaId": "Nem lehet lekérni a média szerver azonosítóját",
    "AlreadyConnectedOrg": "A média szerver már egy másik szervezettel van társítva",
    "AlreadyBoundMedia": "Ez a szervezet már kötött egy média szervert, nem tud még egyet kötni",
    "DeleteSecondaryConfirmation": "A média szerver törlése után az adatokat nem lehet visszaállítani, kérjük, erősítse meg újra."
  },
  "cloudDiskMge": {
    "totalStorage": "ÖSSZES TÁROLÓHELY",
    "GetMore": "Több tárhely beszerzése",
    "StorageSpace": "Tárhely",
    "Adjustment": "Beállítás",
    "moreSpace": "Több tárhely beszerzése",
    "PublicStorage": "Nyilvános tároló",
    "PublicStorageUsed": "Nyilvános tároló használatban",
    "PublicStorageLasted": "Nyilvános tároló maradt",
    "IndividualStorageUsed": "Személyes tároló használatban",
    "IndividualStorageLasted": "Személyes tároló maradt",
    "storageSpace": "Tárhely beállítása",
    "tableUserName": "Felhasználó név",
    "tableUsedSpace": "Használt hely",
    "tableAvailableSpace": "Elérhető hely",
    "tableActiveTime": "Legutóbbi aktivitás időpontja",
    "tableOperate": "Műveletek",
    "cleanup": "Törléshez szóló jegyzet",
    "IndividualStorageSpaceAdjustment": "Személyes tároló beállítása",
    "titleTotal": "Összesen",
    "PublicDisk": "Nyilvános felhő",
    "IndividualDisk": "Személyes felhő",
    "PerUser": "Felhasználónként",
    "UsersInTotal": "Összes felhasználó",
    "cancel": "Mégse",
    "confirm": "Megerősítés",
    "save": "Mentés",
    "addSuccess": "Sikeres hozzáadás!",
    "addError": "Hozzáadás sikertelen!",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "delSuccess": "Sikeres törlés!",
    "delError": "Törlés sikertelen!",
    "error3000": "A művelet nem sikerült, mert a tároló teljes mérete meghaladta a maximális méretet.",
    "error3003": "Művelet sikertelen, kérjük, ellenőrizze, hogy be van-e állítva egy média szerver.",
    "IndividualStorage": "Személyes tároló",
    "NoteToCleanup": "Törléshez szóló jegyzet",
    "updatePersonalSuccess": "A felhő tárolóhelye majdnem tele van, kérjük, takarítsa ki időben",
    "updatePersonalSuccess1": "Sikeresen módosítva és mentve",
    "storageUsage": "Személyes tároló használata",
    "bindIndividualstorage": "Felhasználók, akik személyes felhő tárolót használhatnak",
    "UserIndividualstorage": "Felhasználók, akik már beállítottak személyes felhő tárolót",
    "Notificationsuccessfully": "Értesítés sikeresen elküldve",
    "Notificationfailed": "Értesítés küldése sikertelen",
    "tableName": "Név",
    "userID": "Felhasználó ID"
  },
  "dashboard": {
    "exportPdf": "PDF exportálás",
    "or": "-",
    "warrantyCompletionRate": "Javítási befejezés aránya",
    "frequencyOfEachModule": "A javítási arány minden funkcionális modul esetében",
    "repairHandling": "A javítás feldolgozási állapota",
    "sourceSwitchInput": "Bemeneti kapcsoló",
    "micVol": "Mikrofon hangerő",
    "volumeSpeaker": "Hangszóró hangerő",
    "airAonditioner": "Légkondicionáló",
    "Curtain": "Projektor képernyő",
    "remoteControlIntelligent": "Távvezérlő",
    "RS232Control": "Serial vezérlés",
    "lockElectronic": "Elektronikus zárak",
    "Repairreportcompleted": "Javítva",
    "Totalnumberofrepairsreported": "Összes javítás",
    "Warrantycompletionrate": "Javítási befejezés aránya",
    "startDate": "Kezdési dátum",
    "endDate": "Befejezési dátum",
    "year": "év",
    "month": "hónap",
    "dayTian": "nap",
    "placeholderDate": "Dátum kiválasztása",
    "placeholderDateTime": "Idő kiválasztása",
    "devicesNub": "Eszközök",
    "userNub": "Felhasználók",
    "powerNub": "Teljesítmény (KW/H)",
    "storageUsed": "Használt tároló (%)",
    "userLoginDevice": "Felhasználói bejelentkezési aktív időszak",
    "devicePowerConsumption": "Minden eszköz napi áramfogyasztása",
    "externalDeviceUsageTime": "Külső eszközök használata",
    "equipmentRunningTime": "Terminál eszközök használata",
    "cloudStorageSpace": "Tároló használat",
    "powerConsumptionPort": "Minden tárolóport áramfogyasztása",
    "mostPopularFile": "Legnépszerűbb fájl",
    "commonFunctions": "Gyakran használt funkciók",
    "commonlyUsed": "Gyakran használt műsorszórási módszer",
    "fileName": "Fájl neve",
    "usageCount": "Használati szám",
    "electricityConsumption": "Áramfogyasztás",
    "publicStorageUsed": "Nyilvános tároló használatban",
    "publicStorageLasted": "Nyilvános tároló maradt",
    "individualStorageUsed": "Egyéni tároló használatban",
    "individualStorageLasted": "Egyéni tároló maradt",
    "notification": "Értesítés",
    "audioBroadcast": "Audió műsorszórás",
    "videoBroadcast": "Videó műsorszórás",
    "ac": "Légkondicionáló",
    "hDMISwitch": "HDMI kapcsoló",
    "powerControl": "Áramvezérlés",
    "powercontrol": "Áramvezérlés",
    "Lock": "Zár",
    "volumeAdjust": "Hangerő szabályozás",
    "projectionScreen": "Projektor képernyő",
    "today": "Ma",
    "yesterday": "Tegnap",
    "thisWeek": "Ezen a héten",
    "lastWeek": "Múlt héten",
    "lastMonth": "Múlt hónap",
    "thisMonth": "E hónap",
    "times": "Alkalom",
    "usage": "Használati szám",
    "eachrTitle": "Percek",
    "total": "Összesen",
    "NMPSystemissue": "NMP rendszer hiba",
    "displayPower": "NMP külső eszköz hiba",
    "externalPower": "MBX rendszer hiba",
    "screen": "MBX külső eszköz hiba",
    "TotalRepairs": "Összes javítás",
    "Repaired": "Javítva",
    "Unrepaired": "Javítatlan",
    "day": "NAP",
    "Minutes": "Percek",
    "powerConsumption": "Percek",
    "Date": "Dátum",
    "kw": "KW",
    "month1": "HÉ",
    "month2": "KED",
    "month3": "SZER",
    "month4": "CSÜT",
    "month5": "PEN",
    "month6": "SZO",
    "month7": "VAS",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "Már",
    "enmonth4": "Ápr",
    "enmonth5": "Máj",
    "enmonth6": "Jún",
    "enmonth7": "Júl",
    "enmonth8": "Aug",
    "enmonth9": "Szept",
    "enmonth10": "Okt",
    "enmonth11": "Nov",
    "enmonth12": "Dec",
    "noData": "Nincs adat"
  },
  "input": {
    "fivedigits": "Kérem, adjon meg egy pozitív egész számot 5 számjegyen belül",
    "titlUserNameField": "Ez a felhasználónév kötelező.",
    "thisField": "Ez a mező kötelező.",
    "ChooseGroup": "Válasszon csoportot",
    "placeholder": "Választás",
    "placeholder_type": "Kérem, válassza ki az eszközvezérlő típusokat",
    "titlRealNameField": "A jelszó kötelező.",
    "thisPasswordField": "A jelszó kötelező.",
    "titlPassWordNub": "Kevesebb mint 15 karakter",
    "Post": "Csak számok",
    "passwordNoChinese": "Ez a bemeneti mező nem tölthető ki kínai karakterekkel"
  },
  "transfer": {
    "all": "Minden",
    "Choose": "Választás",
    "Selected": "Kiválasztott",
    "Subordinate": "Alárendelt"
  },
  "setting": {
    limitPngGif: 'Csak PNG / GIF formátum támogatott',
    limit3M: 'A kép mérete nem haladhatja meg a 3 MB-ot',
    setting_door_Wallpaper_text: 'Ajánlott képméret: 1280x800, PNG vagy GIF formátum',

    "reduction": "Visszaállítás",
    "limitJpg": "A feltöltött profilkép csak PNG formátumban lehet!",
    "limit2M": "A feltöltött profilkép mérete nem haladhatja meg a 2 MB-ot!",
    "choseFile": "Fájl kiválasztása",
    "textOne": "1. Ajánlott LOGÓ kép: méret 117*40, PNG formátumban",
    "textTwo": "2. A feltöltés befejezése után kérjük, forduljon a Touch Panel-hez, és győződjön meg arról, hogy a Touch Panel csatlakozik az internethez, majd kattintson az eredeti logóra az újratöltéshez.",
    "customizeLogo": "Touch Panel Logó Beállítása",
    "addSuccess": "Beállítás sikeres!",
    "settingIp": "Fájl Tárolási IP Beállítása",
    "ServerIP": "Szerver IP Cím:",
    "ServerPort": "Szerver Port:",
    "btnSave": "Mentés",
    "TimeZoneSetting": "Időzóna Beállítása",
    "CurrentTime": "Jelenlegi idő:",
    "CurrentTimeZone": "Jelenlegi időzóna:",
    "httpsSetting": "Fájl Tárolás:",
    "utcName": "Greenwich Mean Time UTC/GMT",
    "utc0": "Greenwich Mean Time, Egyesült Királyság, Lisszabon, Torshavn, London, Dublin, Edinburgh",
    "utc0_5": "",
    "utc1": "Közép-Európa, Nyugat-Afrika, Nyugat-Közép-Afrika, Németország, Írország, Franciaország, Amszterdam, Olaszország, Berlin, Róma, Spanyolország, Prága, Belgrád, Brüsszel, Párizs, Madrid, Tunézia, Gabon, Marokkó",
    "utc1_5": "",
    "utc2": "Kelet-Európa, Közép-Afrika, Törökország, Izrael, Dél-Afrika, Isztambul, Kairó, Athén, Damaszkusz",
    "utc2_5": "",
    "utc3": "Kelet-Afrika, Oroszország, Bagdad, Kuvait, Moszkva, Szentpétervár",
    "utc3_5": "Irán",
    "utc4": "Abu Dzabi, Tbiliszi, Dubai, Mauritius, Port Louis",
    "utc4_5": "Afganisztán",
    "utc5": "Pakisztán, Türkmenisztán, Maldív-szigetek, Üzbegisztán, Örményország, Tádzsikisztán, India, Mumbai, Újdelhi, Bangalore, Kalkutta",
    "utc5_5": "India, Srí Lanka",
    "utc6": "Novoszibirszk, Kirgizisztán, Banglades, Bhután",
    "utc6_5": "Kókusz-szigetek, Ausztrália, Vietnám",
    "utc7": "Thaiföld, Bangkok, Hanoi, Jakarta",
    "utc7_5": "",
    "utc8": "Kína, Malajzia, Fülöp-szigetek, Szingapúr, Tajvan Kína, Makaó Kína, Hongkong Kína",
    "utc8_5": "",
    "utc9": "Japán, Dél-Korea, Tokió, Szöul, Szapporo, Osaka, Kelet-Timor",
    "utc9_5": "Ausztrál Közép Idő",
    "utc10": "Ausztrália, Vladivisztok, Guam, Canberra, Melbourne, Sydney, Pápua Új-Guinea",
    "utc10_5": "Lord Howe-sziget Új-Dél-Wales, Ausztrália",
    "utc11": "Salamon-szigetek, Szahalin-sziget",
    "utc11_5": "Norfolk-sziget, Ausztrália",
    "utc12": "Új-Zéland, Auckland, Wellington, Fidzsi, Új-Zéland, Nauru",
    "utc12_5": "",
    "utc13": "Zöld-foki-szigetek, Azori-szigetek",
    "utc13_5": "",
    "utc14": "Dél-Georgia, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brazília, Santiago, El Salvador, Brasilia, Uruguay, Argentína, Suriname",
    "utc15_5": "Újfundlandi Szabványidő",
    "utc16": "Venezuela, Bolívia, Paraguay, Chile",
    "utc16_5": "Venezuela",
    "utc17": "Keleti Idő (USA és Kanada), Kolumbia, Toronto, Ecuador, Peru, Kuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "USA és Kanada Központi Idő, Mexikóváros, Monterrey, Chicago, Houston, New Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Hegyi Idő, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Csendes-óceáni Idő, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaszka",
    "utc21_5": "Francia Polinézia, Marquesas-szigetek",
    "utc22": "Hawaii",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Eszköz neve:",
    "Time": "Idő:",
    "startDate": "Kezdési dátum",
    "endedDate": "Befejezési dátum",
    "or": "-",
    "Problem": "Probléma:",
    "btnSearch": "Keresés",
    "tableNO": "Nem",
    "tableDeviceName": "Eszköz neve",
    "tableGroup": "Csoport",
    "tableStatus": "Állapot",
    "tableDeliveredTime": "Szállítási idő",
    "tableSubmitter": "Beküldő",
    "tableUpdatingTime": "Frissítési idő",
    "tableProblem": "Probléma",
    "tableAdmin": "IT-admin",
    "tableAdminReply": "Admin válasz",
    "tableAttachment": "Csatolmány",
    "state0": "Szállítva",
    "state1": "Folyamatban",
    "state2": "Befejezve",
    "Problem100": "MIND",
    "Problem0": "Rendszerhiba",
    "Problem1": "Külső eszköz hiba",
    "ProblemType": "",
    "ProblemType0": "Teljesítményvezérlés",
    "ProblemType1": "HDMI kapcsoló",
    "ProblemType2": "Mikrofon",
    "ProblemType3": "Hangszóró",
    "ProblemType4": "Légkondicionáló",
    "ProblemType5": "Projektor képernyő",
    "ProblemType6": "Elektromos zár",
    "ProblemType7": "A/V közvetítés",
    "ProblemType8": "IR vezérlés",
    "ProblemType9": "Serial vezérlés",
    "dialogDeviceName": "Eszköz neve",
    "dialogDeviceID": "Eszköz azonosító",
    "dialogGroup": "Csoport",
    "dialogSubmitter": "Beküldő",
    "dialogStatus": "Válassza ki az állapotot",
    "dialogProblem": "Probléma",
    "dialogNotes": "Megjegyzések",
    "dialogRepairation": "Javítás",
    "dialogInProcess": "Folyamatban",
    "dialogCompleted": "Befejezve",
    "editSuccess": "Sikeres szerkesztés!",
    "editError": "Szerkesztés sikertelen!",
    "problemRequired": "Kérem válassza ki a probléma típusát",
    "detailRequired": "Kérem részletesen írja le a problémát",
    "statusRequired": "Kérem válassza ki a napló állapotát",
    "btnCancel": "Mégse",
    "DeliveredTime": "Szállítási idő",
    "UpdatingTime": "Frissítési idő",
    "ITAdmin": "IT-admin",
    "AdminReply": "Admin válasz",
    "Note": "Megjegyzés",
    "Detail": "Részletek",
    "controlPanel": "Vezérlőpanel",
    "DeviceType": "Típus",
    "dialogDeliveredTime": "Szállítási idő",
    "Submitter": "Beküldő"
  },
  "remoteControl": {
    "QuickActionName": "Név",
    "DeviceType": "Típus",
    "Description": "Leírás",
    "tableDescription": "Leírás",
    "editRemoteControl": "Távvezérlő kód szerkesztése",
    "QuickActionNameInput": "Név",
    "DescriptionInput": "Leírás",
    "save": "Mentés",
    "Brand": "Márka",
    "Model": "Modell",
    "EditACControlCode": "Légkondicionáló vezérlő kód szerkesztése",
    "acBrand": "Légkondicionáló márka",
    "acModel": "Légkondicionáló modell"
  },
  "card": {
    "btnAddCard": "Kártya hozzáadása",
    "btnBatchAddCard": "Tömeges kártya hozzáadása",
    "tableCard": "Kártyaszám",
    "tableState": "Állapot",
    "tableUser": "Felhasználó hozzárendelése",
    "tableID": "Felhasználónév",
    "tableType": "Kártyatípus",
    "tableFfective": "Lejárati dátum",
    "dialogCard": "Kártyaszám:",
    "dialogState": "Állapot:",
    "dialogUser": "Felhasználó hozzárendelése:",
    "dialogID": "Felhasználónév:",
    "dialogType": "Kártyatípus:",
    "dialogFfective": "Lejárati dátum:",
    "dialogRemarks": "Megjegyzés:",
    "dialogAddTitle": "Kártya hozzáadása",
    "dialogEidtTitle": "Kártya szerkesztése",
    "code2201": "A kártya lejárati ideje helytelen formátumban van",
    "code2202": "Ez a kártya már hozzárendelésre került",
    "code2203": "Ez a felhasználó már hozzárendelésre került",
    "code2204": "Ez a kártya nincs hozzárendelve",
    "mastCard": "Mester kártya",
    "regularCard": "Általános kártya",
    "permanent": "Állandó",
    "coxPermanent": "Állandó",
    "coxTime": "Bizonyos időtartam",
    "tableDeviceName": "Eszköz neve",
    "tableDeviceID": "Eszközkód",
    "tableOperating": "Művelet",
    "tableOperatingTime": "Művelet időpontja",
    "tableCardID": "Kártyaszám",
    "tableCardType": "Kártyatípus",
    "tabluserName": "Felhasználónév",
    "tabluserId": "Felhasználói azonosító",
    "unlockPanel": "Panel feloldása",
    "unlock": "Ajtó feloldása",
    "conAll": "Minden",
    "btnEnable": "Engedélyezés",
    "btnDisable": "Letiltás",
    "enableSuccess": "Sikeres engedélyezés",
    "stopSuccess": "Sikeres letiltás",
    "enableError": "Engedélyezés sikertelen",
    "stopError": "Letiltás sikertelen",
    "batchCard": "Tömeges kártyaszám:",
    "titlCardField": "A kártyaszám nem lehet üres",
    "titlCardFieldFormat": "Csak betűk és számok",
    "dialogBachAddTitle": "Tömeges kártya hozzáadása",
    "pleaseTryAgain1": "Hibás kártyaszám (NEM. :",
    "pleaseTryAgain2": "), próbálja újra"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/hu.js